export enum FinancialPermissionLevel {
    None = 0,
    Hidden = 1,
    AuthorizedSignatory = 2,
    NonSignatory = 3
}

export namespace FinancialPermissionLevel {
    export function toString(financialPermissionLevel: FinancialPermissionLevel): string {
        switch (financialPermissionLevel) {
          case FinancialPermissionLevel.None:
            return 'None';
            case FinancialPermissionLevel.Hidden:
                return 'Hidden Bank Accounts';
            case FinancialPermissionLevel.AuthorizedSignatory:
                return 'Authorized Signatory';
            case FinancialPermissionLevel.NonSignatory:
                return 'Non-Signatory';
            default:
                return null;
        }
    }

    export function listAll(): FinancialPermissionLevel[] {
        return [FinancialPermissionLevel.AuthorizedSignatory, FinancialPermissionLevel.NonSignatory];
    }

    export function parse(fpl: string): FinancialPermissionLevel {
        return FinancialPermissionLevel[fpl];
    }
}
